/* LPO owns options; Shopify native variants own exact full-order prices. */
(() => {
  'use strict';
  const packCounts = [25, 50, 100, 250, 500, 1000, 2000];
  const stickerCounts = [3, 4, 5, 6, 7, 8, 9, 10];
  const findVariant = (variants, stickers, packs) => variants.find(v => Number(v.options[0]) === Number(stickers) && Number(v.options[1]) === Number(packs));
  const validMatrix = variants => variants.length === 56 && stickerCounts.every(s => packCounts.every(p => {
    const v = findVariant(variants, s, p);
    return v && Number.isSafeInteger(v.price) && v.price > 0 && /^(SP100-[BP])-\d+-\d+$/.test(v.sku);
  })) && new Set(variants.map(v => String(v.id))).size === 56;
  if (typeof module !== 'undefined' && module.exports) module.exports = {findVariant, validMatrix, packCounts, stickerCounts};
  if (typeof document === 'undefined') return;

  function start(marker) {
    if (marker.dataset.lpoBridgeReady) return;
    marker.dataset.lpoBridgeReady = 'true';
    const root = marker.closest('[data-product-id]');
    if (!root || !['budget-die-cut-sticker-packs', 'premium-die-cut-sticker-packs'].includes(root.dataset.productHandle)) return;
    const form = root.querySelector('form[action*="/cart/add"]');
    const button = form?.querySelector('[data-add-to-cart]');
    const nativeId = form?.querySelector('[name="id"]');
    const status = marker.querySelector('[data-pack-status]');
    const setText = (element, text) => { if (element.textContent !== text) element.textContent = text; };
    let variants;
    try { variants = JSON.parse(marker.querySelector('[data-pack-native-variants]').textContent); } catch { variants = []; }
    let ready = false;
    let refreshSelection = () => {};
    // Keep the submission guard even if the matrix or LPO rendering is invalid.
    // Native theme availability handlers can independently re-enable the button.
    form?.addEventListener('submit', event => {
      refreshSelection();
      if (!ready) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    if (!form || !button || !nativeId || !validMatrix(variants)) {
      setText(status, 'Please contact us for help with this pack configuration.');
      if (button) button.disabled = true;
      return;
    }
    root.classList.add('pp-sticker-pack-lpo');
    const money = new Intl.NumberFormat('en-GB', {style:'currency', currency:marker.dataset.currency || 'GBP'});
    let quantity = form.querySelector('[name="quantity"]');
    if (!quantity) {
      quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      form.append(quantity);
    }
    quantity.value = '1';
    const option = name => root.querySelector(`[data-option="${name}"]`);
    function update() {
      const selected = variants.find(v => String(v.id) === String(nativeId.value));
      const stickerOption = option('Stickers per pack');
      const packOption = option('Packs per order');
      const stickers = Number(stickerOption?.querySelector('input[type="radio"]:checked')?.value ?? stickerOption?.querySelector('select')?.value);
      const packs = Number(packOption?.querySelector('input[type="radio"]:checked')?.value);
      ready = marker.dataset.commercialReady === 'true' && selected?.available && stickers === Number(selected.options[0]) && packs === Number(selected.options[1]) && quantity.value === '1';
      button.disabled = !ready;
      setText(status, marker.dataset.commercialReady !== 'true' ? 'This product is being prepared.' : !ready ? 'Select your pack options to continue.' : '');
      if (!selected) return;
      setText(root.querySelector('[data-pack-contents]'), `${selected.options[1]} packs × ${selected.options[0]} stickers = ${Number(selected.options[1]) * Number(selected.options[0])} stickers`);
      const total = root.querySelector('[data-pack-total]');
      if (total.dataset.variant !== String(selected.id)) { setText(total, money.format(selected.price / 100)); total.dataset.variant = String(selected.id); }
      const stickyPrice = document.querySelector('.pp-sticky-bar__price');
      if (stickyPrice && !window.PPVat) setText(stickyPrice, selected.priceHtml.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim());
      const stickerRadios = [...(stickerOption?.querySelectorAll('input[type="radio"]') || [])];
      if (stickerRadios.length === 8 && stickerRadios.every(r => stickerCounts.includes(Number(r.value)))) {
        const grid = stickerRadios[0].closest('.cl-po--radio-item, .cl-po__radio-item, label')?.parentElement;
        grid?.classList.add('pp-sticker-count-grid');
        for (const radio of stickerRadios) {
          radio.setAttribute('aria-label', `${radio.value} stickers per pack`);
          radio.closest('.cl-po--radio-item, .cl-po__radio-item, label')?.classList.add('pp-sticker-count-item');
        }
      }
      if (!packOption || !Number.isFinite(stickers)) return;
      const radios = [...packOption.querySelectorAll('input[type="radio"]')];
      if (radios.length !== 7 || radios.some(r => !packCounts.includes(Number(r.value)))) return;
      const firstRow = radios[0].closest('.cl-po--radio-item, .cl-po__radio-item, label');
      const grid = firstRow?.parentElement;
      if (!grid) return;
      grid.classList.add('pp-tier-grid');
      for (const radio of radios) {
        const row = radio.closest('.cl-po--radio-item, .cl-po__radio-item, label');
        const v = findVariant(variants, stickers, radio.value);
        if (!row || !v) continue;
        const fullOrderLabel = v.priceHtml.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        radio.setAttribute('aria-label', `${radio.value} packs with ${stickers} stickers per pack; complete order ${fullOrderLabel}.`);
        row.classList.add('pp-tier-item');
        row.classList.toggle('cl-po--selected', radio.checked);
        let card = row.querySelector('.pp-tier');
        if (!card) {
          card = document.createElement('div');
          card.className = 'pp-tier';
          card.setAttribute('aria-hidden', 'true');
          card.innerHTML = '<div class="pp-tier__col-left"><div class="pp-tier__qty"></div><div class="pp-tier__units">PACKS</div></div><div class="pp-tier__col-right"><div class="pp-tier__unit"></div><div class="pp-tier__each">PER PACK</div></div>';
          card.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); radio.click(); });
          row.append(card);
        }
        const each = money.format(v.price / Number(radio.value) / 100);
        const qtyText = card.querySelector('.pp-tier__qty');
        const unitText = card.querySelector('.pp-tier__unit');
        if (qtyText.textContent !== radio.value) qtyText.textContent = radio.value;
        if (unitText.textContent !== each) unitText.textContent = each;
      }
      window.PPVat?.updateProduct(root);
    }
    refreshSelection = update;
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    };
    root.addEventListener('change', () => { schedule(); setTimeout(schedule, 80); });
    document.addEventListener('options:rendered', schedule);
    document.addEventListener('options:price', schedule);
    root.addEventListener('variantChange', schedule);
    document.addEventListener('variant:change', schedule);
    new MutationObserver(schedule).observe(root.querySelector('.product-single__meta') || root, {childList:true, subtree:true});
    update();
  }
  const boot = () => document.querySelectorAll('[data-sticker-pack-lpo]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
